import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fcf28478&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=fcf28478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf28478",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcf28478')) {
      api.createRecord('fcf28478', component.options)
    } else {
      api.reload('fcf28478', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fcf28478&scoped=true&", function () {
      api.rerender('fcf28478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/start/index.vue"
export default component.exports